<template>
    <div class="shows-page">
        <div class="container">
            <div class="handle-box">
                <el-button type="primary" @click="tian = true" icon="el-icon-plus">添加买家秀</el-button>
            </div>
            <el-table :data="tableData" border class="table table-then-card" ref="filterTable" v-loading="loading">
                <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
                <el-table-column label="图片(点击查看)" align="center" prop="imgList" width="200">
                    <template slot-scope="scope">
                        <el-image class="table-td-thumb" preview-teleported :src="scope.row.imgList[0]"
                            :preview-src-list="scope.row.imgList" :z-index="10">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="subTime" label="发布时间" align="center" width="200"></el-table-column>
                <el-table-column label="操作" width="220" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" icon="el-icon-edit-outline" style="color:green"
                            @click="handleUp(scope.$index, scope.row)">
                            修改
                        </el-button>
                        <el-button type="text" icon="el-icon-delete" style="color:#ff0000"
                            @click="handleDe(scope.$index, scope.row)">
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 手机端卡片列表 -->
            <div class="mobile-card-list" v-loading="loading">
                <div v-for="(row, idx) in tableData" :key="idx" class="mc-card">
                    <div class="mc-thumb-area">
                        <el-image v-if="row.imgList && row.imgList[0]" class="mc-img" preview-teleported :src="row.imgList[0]"
                            :preview-src-list="row.imgList" :z-index="10" fit="cover"></el-image>
                        <div class="mc-thumb-info">
                            <div class="mc-title">{{ row.title }}</div>
                            <div class="mc-subtitle">{{ row.subTime }}</div>
                        </div>
                    </div>
                    <div class="mc-actions">
                        <el-button size="small" type="primary" icon="el-icon-edit-outline" @click="handleUp(idx, row)">修改</el-button>
                        <el-button size="small" type="danger" icon="el-icon-delete" @click="handleDe(idx, row)">删除</el-button>
                    </div>
                </div>
                <div v-if="!loading && tableData.length === 0" style="text-align:center;color:#909399;padding:30px 0;">暂无数据</div>
            </div>
            <div class="pagination">
                <el-pagination @current-change="handleCurrentChange" :current-page.sync="page" :page-size="size"
                    layout="total, prev, pager, next" :total="total">
                </el-pagination>
            </div>
        </div>


        <el-dialog title="添加买家秀" :visible.sync="tian" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="rules" ref="obj" label-width="150px" :model="obj" status-icon>
                <el-form-item label="图 片" prop="images">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="upload" :auto-upload="true" :on-success="handleAvatarSuccess" :file-list="fileList">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="标 题" prop="title">
                    <el-input placeholder="请输入标题" prefix-icon="el-icon-edit" v-model="obj.title"></el-input>
                </el-form-item>
                <el-form-item label="内 容" prop="content">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="obj.content" class="editor" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subAdd('obj')">确 定</el-button>
                <el-button @click="tian = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog title="修改商品" :visible.sync="upg" :width="dialogWidthSmall">
            <el-form label-position="left" :rules="ruless" ref="upObj" label-width="150px" :model="upObj" status-icon>
                <el-form-item label="图 片" prop="images">
                    <el-upload :before-upload="handleBeforeUpload" :action="this.$base.file" list-type="picture-card"
                        ref="upload" :auto-upload="true" :on-success="handleAvatarSuccess" :file-list="fileListU">
                        <i slot="default" class="el-icon-plus"></i>
                        <div slot="file" slot-scope="{file}">
                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span v-if="!disabled" class="el-upload-list__item-delete" @click="handleRemove(file)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl">
                    </el-dialog>
                </el-form-item>
                <el-form-item label="标 题" prop="title">
                    <el-input placeholder="请输入标题" prefix-icon="el-icon-edit" v-model="upObj.title"></el-input>
                </el-form-item>
                <el-form-item label="内 容" prop="content">
                    <editor style="min-width: 200px; max-width: 600px;" v-model="upObj.content" class="editor" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="subUp('upObj')">确 定</el-button>
                <el-button @click="upg = false">取 消</el-button>
            </div>
        </el-dialog>


    </div>
</template>

<script>
import { queryShows, addShow, updateSetShows, deleteByShows } from '@/api';
export default {
    name: "ShowsAdm",
    data() {
        return {
            url: '',
            loading: true,
            tableData: [],
            page: 1,
            size: 10,
            total: 0,
            upg: false,
            tian: false,
            dialogVisible: false,
            dialogImageUrl: '',
            fileList: [],
            fileListU: [],
            obj: {
                title: '',
                images: [],
                content: ''
            },
            upObj: {},
            rules: {
                images: [
                    { required: true, message: "请上传商品图片", trigger: "blur" }
                ],
                title: [
                    { required: true, message: "标题不能为空", trigger: "blur" }
                ],
                content: [
                    { required: true, message: "内容不能为空", trigger: "blur" }
                ]
            },
            ruless: {
                images: [
                    { required: true, message: "请上传商品图片", trigger: "blur" }
                ],
                title: [
                    { required: true, message: "标题不能为空", trigger: "blur" }
                ],
                content: [
                    { required: true, message: "内容不能为空", trigger: "blur" }
                ]
            }
        };
    },
    computed: {
        dialogWidthSmall() {
            return window.innerWidth < 768 ? '95%' : '500px';
        }
    },
    methods: {
        // 判断上传的是否为图片
        handleBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            return suffix || suffix2 || suffix3
        },
        handleRemove(file, fileList) {
            const uploadFiles = this.$refs.upload.uploadFiles;
            for (let i in uploadFiles) {
                if (file.url === uploadFiles[i].url) {
                    uploadFiles.splice(i, 1);
                    if (this.upg) {
                        this.upObj.images.splice(i, 1);
                        this.fileListU.splice(i, 1);

                    } else {
                        this.obj.images.splice(i, 1);
                        this.fileList.splice(i, 1);
                    }
                }
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        //上传图：后端返回 { key: objectKey, url: 预签名URL }
        handleAvatarSuccess(res, file) {
            if (res.code != 0) {
                this.$message.error('上传失败')
            } else {
                const data = res.data || {};
                const key = data.key;
                const previewUrl = data.url;
                file.url = previewUrl;
                if (this.upg) {
                    this.upObj.images.push(key);
                    this.fileListU.push({ url: previewUrl });
                } else {
                    this.obj.images.push(key);
                    this.fileList.push({ url: previewUrl });
                }
                this.$refs.upload.clearFiles()
            }
        },
        //修改指定信息
        subUp(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定修改该信息?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.upObj;
                        obj.images = JSON.stringify(obj.images);
                        updateSetShows(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.upg = false;
                            this.$message.success(msg);
                            this.getData();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //添加信息
        subAdd(formName) {
            this.$refs[formName].validate((volid) => {
                if (volid) {
                    this.$confirm("是否确定添加该信息?", "提示", {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning",
                    }).then(() => {
                        let obj = this.obj;
                        obj.images = JSON.stringify(obj.images);
                        addShow(obj).then((res) => {
                            let { code, msg } = res;
                            if (code != 0) {
                                this.$message.warning(msg);
                                return false;
                            }
                            this.tian = false;
                            this.$message.success(msg);
                            this.getData();
                        })
                    })
                } else {
                    return false;
                }
            })
        },
        //修改
        handleUp(index, row) {
            let obj = JSON.stringify(row);
            obj = JSON.parse(obj)
            obj.images = JSON.parse(obj.images);
            this.upObj = obj;
            const signedList = Array.isArray(row.imgList) ? row.imgList : [];
            let list = [];
            for (let i = 0; i < obj.images.length; i++) {
                list.push({ url: signedList[i] || '' });
            }
            this.fileListU = list;
            this.upg = true;
        },
        //删除该信息
        handleDe(index, row) {
            this.$confirm("此操作将永久删除该信息, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                deleteByShows(row.id).then((res) => {
                    if (res.code != 0) {
                        this.$message.error('删除失败');
                        return false;
                    }
                    this.$notify.success({
                        title: "系统提示",
                        message: "删除该信息成功",
                        showClose: false,
                    });
                    this.loading = true
                    this.tableData = this.tableData.filter((todo) => {
                        return todo.id != row.id;
                    })
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            });
        },
        //切换页数
        handleCurrentChange(val) {
            this.page = val;
            this.getData();
        },
        async getData() {
            try {
                this.loading = true;
                let pageNum = this.page;
                let pageSize = this.size;
                let res = await queryShows({ pageNum, pageSize });
                this.tableData = res.list;
                this.total = res.total;
                setTimeout(() => {
                    this.loading = false;
                }, 500)
            } catch (error) {
                this.$message.error('服务器错误');
            }
        }
    },
    created() {
        this.url = this.$base.url;
        this.getData();
    },

};
</script>

<style scoped>
.shows-page {
    height: calc(100vh - 110px);
    overflow-y: auto;
}

.pp {
    margin-top: 10px;
    float: right;
    color: #909399;
}

.handle-box {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}

.table {
    width: 100%;
    font-size: 14px;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 60px;
    height: 60px;
}

.avatar-uploader {
    width: 100px;
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    cursor: pointer;
}

.avatar-uploader-icon {
    font-size: 30px;
    color: #8c939d;
}

.avatar {
    width: 100%;
    height: 100%;
}

/* 手机端适配 */
@media (max-width: 767px) {
  .shows-page {
    height: calc(100vh - 56px);
  }
}

/* 平板端适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .shows-page {
    height: calc(100vh - 56px);
  }
}
</style>